(function () {
    angular.module('bizPartEngage').directive('bizMyRootGoals', bizMyRootGoalsDirective);

    bizMyRootGoalsDirective.$inject = ["bizCore"];

    function bizMyRootGoalsDirective(bizCoreProvider) {
        var directive = {
            restrict: 'E',
            scope: {                
                Goals: '=?goals'                
            },
            templateUrl: bizCoreProvider.getView('bizMyRootGoalsDirective', 'FrontEnd/Modules/EngagementGoals/Views/Directives/myRootGoals.html'),
            bindToController: true,
            controller: bizMyRootGoalsDirectiveController,
            controllerAs: 'vm'
        };

        bizMyRootGoalsDirectiveController.$inject = ["modules.goals.service", "$state", "$rootScope", "$filter"];

        return directive;

        function bizMyRootGoalsDirectiveController(engagementGoalsService, $state, $rootScope, $filter) {
            var vm = this;            

            vm.GetGoals = GetGoals;            
            vm.Init = Init;
            vm.GotoToGoal = GotoToGoal;                        

            function GotoToGoal(goal) {
                $state.go("base.modules.goals.onegoal", { id: goal.Id });
            }            

            function GetGoals() {
                engagementGoalsService.GetGoals(true).then(GetGoalsCallback);

                function GetGoalsCallback(response) {
                    var goals = BizPartCoreHelpers.getResponseValue(response, []);                    
                    vm.Goals = $filter('filter')(goals, { ParentGoalId: -1 });
                }
            }
            
            function Init() {                
                if (vm.Goals === undefined) {
                    vm.GetGoals();
                }
            }

            vm.$onInit = vm.Init;

            $rootScope.$on('GOAL_NEW_DATE_SELECTED', function () {
                vm.GetGoals();
            });
            

            $rootScope.$on('GOALCREATED', function (event, goal) {
                if (goal.ParentGoalId <= 0) {
                    vm.Goals.push(goal);
                }
            });
        }
    }

}());